export default "__VITE_ASSET__vQf$gERZ__"